import { useEffect, useState } from "react"

const DEFAULT_ROW_HEIGHT = 41
const MIN_ROWS = 5
const MAX_ROWS = 200

export function usePricemanTablePageSize(tableWrapRef, options = {}) {
     const {
          minRows = MIN_ROWS,
          maxRows = MAX_ROWS,
          defaultRows = 12,
          rowHeight = DEFAULT_ROW_HEIGHT,
          hasPaginator = true,
     } = options

     const [pageSize, setPageSize] = useState(defaultRows)

     useEffect(() => {
          const wrap = tableWrapRef?.current
          if (!wrap) {
               return undefined
          }

          const measure = () => {
               const containerHeight = wrap.clientHeight
               if (containerHeight <= 0) {
                    return
               }

               const thead = wrap.querySelector(".p-datatable-thead")
               const paginator = wrap.querySelector(".p-paginator")
               const sampleRow = wrap.querySelector(".p-datatable-tbody > tr")
               const theadHeight = thead?.getBoundingClientRect().height ?? rowHeight * 2
               const paginatorHeight = hasPaginator ? (paginator?.getBoundingClientRect().height ?? 48) : 0
               const measuredRowHeight = sampleRow?.getBoundingClientRect().height
               const effectiveRowHeight =
                    measuredRowHeight && measuredRowHeight > 0 ? measuredRowHeight : rowHeight
               const bodyHeight = containerHeight - theadHeight - paginatorHeight
               const next = Math.max(
                    minRows,
                    Math.min(maxRows, Math.floor(bodyHeight / effectiveRowHeight) - 1)
               )

               if (next > 0) {
                    setPageSize((prev) => (prev === next ? prev : next))
               }
          }

          const observer = new ResizeObserver(() => {
               requestAnimationFrame(measure)
          })
          observer.observe(wrap)
          measure()
          const raf = requestAnimationFrame(measure)
          const t = window.setTimeout(measure, 100)

          return () => {
               observer.disconnect()
               cancelAnimationFrame(raf)
               window.clearTimeout(t)
          }
     }, [tableWrapRef, minRows, maxRows, rowHeight, hasPaginator])

     return pageSize
}
